import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { PiWarningCircleBold } from 'react-icons/pi';
import { useDispatch } from 'react-redux';
import { deleteAppointment, deleteAppointmentOtp } from '../../../redux/actions/Files.action';
import logo from "assets/img/Sculpt-logo.png";

const AppoinmentDelete = ({ deleteModal, deleteToggle, appointmentData, currentDate,limits }) => {
  const [otpModal, setOtpModal] = useState(false);
  const [otpData, setOtpData] = useState({ otp: '' })
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch()

  const otpToggle = () => {
    setLoader(true);
    deleteToggle();
    setOtpModal(!otpModal)
    dispatch(deleteAppointment(appointmentData._id)).then(() => {
      deleteToggle();
      setLoader(false);
    })
  };

  const handleOtp = (e) => {
    const { name, value } = e.target;
    setOtpData((prev) => ({
      ...prev, [name]: value
    }))
  }
  
  const handleDeleteAppointment = () => {
    const payload = {
      appointmentId: appointmentData._id,
      otp: otpData.otp
    }
    dispatch(deleteAppointmentOtp(payload, currentDate,limits)).then(() => {
      setOtpData({ otp: '' })
      setOtpModal(!otpModal);
    })
  }


  return (
    <>
      {loader && (
        <div className="loaderAdd">
          <div className="loader_line"><img src={logo} className="w-[130px]" /></div>
        </div>
      )}
      <Modal show={deleteModal} onHide={deleteToggle}>
        <Modal.Body className="p-5">
          <div>
            <PiWarningCircleBold className="text-7xl w-100 text-danger" />
          </div>
          <div className="text-center mt-4">
            <h3>Are You Sure ?</h3>
            <p className="text-md">
              Do you really want to delete these records?
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className="">
          <Button
            variant="secondary"
            onClick={deleteToggle}
            className="px-4 bg-transparent border-[1px] text-black border-green-color"
          >
            No
          </Button>
          <Button
            type="submit"
            className="bg-danger border-0 px-4"
            onClick={otpToggle}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* otp modal open in click yes */}

      <Modal show={otpModal} onHide={otpToggle}>
        <Modal.Body className="p-5">
          <Form.Group className="mb-3" controlId="problem">
            <Form.Label>OTP</Form.Label>
            <Form.Control
              type="text"
              name="otp"
              value={otpData.otp}
              onChange={handleOtp}
              placeholder="Enter OTP"
              className="shadow-none focus:!border-theme-dark"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="">
          <Button
            variant="secondary"
            onClick={otpToggle}
            className="px-4 bg-transparent border-[1px] text-black border-green-color"
          >
            No
          </Button>
          <Button
            type="submit"
            className="!bg-theme-dark border-0 px-4"
            onClick={handleDeleteAppointment}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AppoinmentDelete;
